import _isNullOrUndefined from "../internals/is-null-or-undefined";
var exports = {};
var isNullOrUndefined = _isNullOrUndefined;
var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};
export default exports;